export type Environment = 'local' | 'dev' | 'prod' | 'stage';

const webUrlEnvironmentMap: Record<Environment, string[]> = {
  prod: ['https://mollerbil.no', 'https://mollerbil-cms-mollerbilno.prod.mollercloud.no'],
  stage: ['https://stage.mollerbil.no', 'https://mollerbil-cms-mollerbilno.stage.mollercloud.no'],
  dev: ['https://dev.mollerbil.no', 'https://mollerbil-cms-mollerbilno.dev.mollercloud.no/'],
  local: ['localhost:'],
};

const getEnvironmentOnClient = (): Environment => {
  const url = window.location.href;

  if (webUrlEnvironmentMap.prod.some((prodUrl) => url.startsWith(prodUrl))) {
    return 'prod';
  }
  if (webUrlEnvironmentMap.dev.some((devUrl) => url.startsWith(devUrl))) {
    return 'dev';
  }
  if (webUrlEnvironmentMap.stage.some((stageUrl) => url.startsWith(stageUrl))) {
    return 'stage';
  }
  if (webUrlEnvironmentMap.local.some((localUrl) => url.includes(localUrl))) {
    return 'local';
  }
  console.error('Could not determine environment from url: %s', url, "returning 'local'");
  return 'local';
};

const getEnvironmentOnServer = (): Environment => {
  const nextEnv = process.env.NEXT_ENV;

  switch (nextEnv) {
    case 'production':
      return 'prod';
    case 'stage':
      return 'stage';
    case 'development':
      return 'dev';
    case 'local':
      return 'local';
    default:
      console.error('Could not determine environment from NEXT_ENV: ', nextEnv, 'returning local');
      return 'local';
  }
};

export const getEnvironment = (): Environment => {
  return typeof window === 'undefined' ? getEnvironmentOnServer() : getEnvironmentOnClient();
};
